/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AdditionalResourceDetailsForFinopsCustomBilling extends models.AdditionalResourceDetailsBase {
    constructor() {
        super();
        this.setDiscriminator("AdditionalResourceDetailsForFinopsCustomBilling");
    }

    getFixupPrototypeFunction() { return AdditionalResourceDetailsForFinopsCustomBilling.fixupPrototype; }

    static newInstance(model: Partial<AdditionalResourceDetailsForFinopsCustomBilling>): AdditionalResourceDetailsForFinopsCustomBilling {
        let obj = Object.assign(new AdditionalResourceDetailsForFinopsCustomBilling(), model);
        AdditionalResourceDetailsForFinopsCustomBilling.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AdditionalResourceDetailsForFinopsCustomBilling>): AdditionalResourceDetailsForFinopsCustomBilling {
        if (!model) return null;
        return AdditionalResourceDetailsForFinopsCustomBilling.newInstance(<AdditionalResourceDetailsForFinopsCustomBilling> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AdditionalResourceDetailsForFinopsCustomBilling) {
        if (!obj) return;

        models.AdditionalResourceDetailsForFinopsCustomBilling.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AdditionalResourceDetailsForFinopsCustomBilling): boolean {
        if (models.AdditionalResourceDetailsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AdditionalResourceDetailsForFinopsCustomBilling.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.quantity === undefined) {
            this.quantity = 0;
        }
        if (this.lookback_period === undefined) {
            this.lookback_period = 0;
        }
    }

    /**
     * Resource Id
     */
    resource_id: string;

    /**
     * Resource Name
     */
    resource_name: string;

    /**
     * Quantity
     */
    quantity: number;

    /**
     * Term for the resource
     */
    term: string;

    /**
     * Lookback period in days
     */
    lookback_period: number;

    /**
     * Region Name
     */
    region: string;

}
